import { forwardRef, InputHTMLAttributes } from 'react';

import classNames from 'classnames';
import { Input as AriaInput } from 'react-aria-components/Input';
import { useIntl } from 'react-intl';

import { Field, IFieldProps, useField } from '../Field/Field';

import styles from './input.module.scss';

interface IInputProps extends InputHTMLAttributes<HTMLInputElement>, IFieldProps {}

const Input = forwardRef<HTMLInputElement, IInputProps>((props, ref) => {
  const {
    id,
    label,
    labelContent,
    helpText,
    errorMessage,
    wrapperClassName,
    className,
    type = 'text',
    placeholder,
    error,
    disabled,
    'aria-describedby': describedBy,
    'aria-invalid': ariaInvalid,
    ...restProps
  } = props;
  const intl = useIntl();
  const { fieldId, descriptionIds } = useField(
    id,
    describedBy,
    helpText,
    errorMessage,
    error,
  );
  return (
    <Field
      {...{
        fieldId,
        label,
        labelContent,
        helpText,
        errorMessage,
        error,
        wrapperClassName,
      }}
    >
      <AriaInput
        {...restProps}
        ref={ref}
        id={fieldId}
        className={classNames(styles.input, className, {
          [styles['input--error']]: error,
        })}
        type={type}
        disabled={disabled}
        aria-invalid={error || ariaInvalid}
        aria-describedby={descriptionIds}
        placeholder={placeholder ? intl.formatMessage({ id: placeholder }) : ''}
      />
    </Field>
  );
});
Input.displayName = 'Input';
export { Input };
